import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation } from 'react-router'
import { SCREEN } from '../../../../common/selectCurrencyUnit/constant'
import { useFormatCurrency } from '../../../../common/selectCurrencyUnit/useFormatCurrency'
import { formatText, valToPercent } from '../../../../helpers/value'
import { HighlightInformation } from '../../../common/header/highlightInformation'
import { selectTopYears } from '../topIndustryPlayers/store/slice'
import { selectHighLight, selectIsLoadingHightLight } from './store/slice'
import { getHighLight } from './store/thunk'

const getSchema = (locale, formatCurrencyWithUnit) => [
  {
    title: 'industryOverview.TOTAL_FDI_OF_THE_LEVEL_INDUSTRY',
    key: 'totalFDI',
    formatVal: (value) => formatCurrencyWithUnit({ value }),
    scrollElementId: 'macroeconomicsId',
  },
  {
    title: 'industryOverview.PROPORTION_OF_ACTIVE_COMPANIES',
    key: 'activeCompanies',
    formatVal: (val) => valToPercent(val, locale),
    scrollElementId: 'businessStatusId',
  },
  {
    title: 'industryOverview.MOST_POPULAR_BUSINESS_SIZE',
    key: 'businessSize',
    formatVal: (val) => formatText(val),
    scrollElementId: 'businessSizeId',
  },
  {
    title: 'industryOverview.MOST_POPULAR_YEAR_OF_OPERATION',
    key: 'businessAge',
    formatVal: (val) => formatText(val),
    scrollElementId: 'businessYearsId',
  },
]

export const Content = () => {
  const dispatch = useDispatch()
  const location = useLocation()
  const { formatCurrencyWithUnit } = useFormatCurrency(SCREEN.INDUSTRY_OVERVIEW)

  const locale = useSelector((state) => state.i18n.locale)
  const data = useSelector(selectHighLight)
  const isLoading = useSelector(selectIsLoadingHightLight)
  const topYears = useSelector(selectTopYears)

  const params = new Proxy(new URLSearchParams(location.search), {
    get: (searchParam, prop) => searchParam.get(prop),
  })

  useEffect(() => {
    if (topYears.length) {
      dispatch(
        getHighLight({
          OrganizationId: params.organizationId,
          FiscalYear: topYears[0],
        }),
      )
    }
  }, [locale, params.organizationId, topYears])

  return (
    <>
      <HighlightInformation
        isLoading={isLoading}
        highlights={getSchema(locale, formatCurrencyWithUnit).map((item) => ({
          ...item,
          detail: data[item.key],
          isI18n: true,
        }))}
      />
    </>
  )
}
